
import { createSlice, } from "@reduxjs/toolkit";

const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    loading: false,
  },
  reducers: {
    loadingOn: (state, action) => {
      return {
        loading: true
      }
    },
    loadingOff: (state, action) => {
      return {
        loading: false
      }
    }
  },
});

export const { loadingOn, loadingOff } = loadingSlice.actions;
export default loadingSlice.reducer;
